<script lang="ts">
    import TemplateIcon from './TemplateIcon.svelte';
    import src from './svg/location_on_FILL0_wght400_GRAD0_opsz24.svg';

    export let scale: number = 1;
</script>

<TemplateIcon {src} alt="Show location" {scale} on:click />
